module.exports = __webpack_public_path__ + "img/top.448a3bba.jpg";